import { gql } from 'graphql-request';

export const QUERY_ZIPCODE_SEARCH = gql`
  query ZipcodeSearch($placeTermInput: PlaceTermInput!) {
    # HC CAPABILITY: pexp-product-access
    # HC CAPABILITY: market-insights-product-access
    # HC CAPABILITY: platform-search-experience
    searchPlace(id: $placeTermInput) {
      places {
        __typename
        description
        placeId
        placeType
        viewport {
          northeastLatitude
          northeastLongitude
          southwestLatitude
          southwestLongitude
        }
        shape
      }
    }
  }
`;
